import { Input } from '@material-ui/core';
import styled from 'styled-components';

import { fontFamilySize, px } from '../../../../../../../../../contrib/ui';

export const IndexInputStyled = styled(Input)`
  min-height: ${px(40)};
  margin-top: 0;
  padding: ${px(5)};
  ${fontFamilySize('Bold', 16)}
  line-height: 1;
  display: flex;
  align-items: center;

  input {
    padding: 0;
    text-align: center;
  }
`;
